export const experienceData = [
    {
        id: 1,
        company: 'Full-stack Web Development Program, Full Time',
        jobtitle: 'Masai School',
        startYear: 'Jan 2022',
        endYear: 'Nov 2022',
        describe: "Spent 1300+ hours mastering algorithms, data structures, and full-stack development Simultaneously developing projects with HTML, JavaScript, React, and Redux. Developed skills in remote pair-programming using GitHub, industry-standard gitflow, And daily standups to communicate and collaborate with remote developers. ",
    },
   
]